module.exports = __webpack_public_path__ + "img/delivery-box.922da658.png";